<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 purchases-order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("PURCHASES_ORDERS.EDIT_PURCHASES_ORDER") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <purchases-order-form
              :loading="loading"
              :purchasesOrderData="purchasesOrder"
              :formErrors="formErrors"
              @purchasesOrderSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import PurchasesOrderForm from "./partials/PurchasesOrderForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesOrder from "./defaultPurchasesOrder";

export default {
  layout: "DashboardLayout",

  components: { PurchasesOrderForm },

  mixins: [alertLeave],

  data() {
    return {
      purchasesOrder: cloneDeep(defaultPurchasesOrder),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("purchasesOrders/get", id);
        this.purchasesOrder =
          this.$store.getters["purchasesOrders/purchasesOrder"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List PurchasesOrders" });
    },

    viewPurchasesOrder() {
      this.alertLeave = false;
      this.$router.push({
        name: "View PurchasesOrder",
        params: { id: this.purchasesOrder.id },
      });
    },

    async handleSubmit(purchasesOrder) {
      this.loading = true;
      const purchasesOrderData = cloneDeep(purchasesOrder);
      if (purchasesOrderData.destinationWarehouse) {
        if (!purchasesOrderData.destinationWarehouse.id) {
          delete purchasesOrderData.destinationWarehouse;
        }
      }
      try {
        await this.$store.dispatch(
          "purchasesOrders/update",
          purchasesOrderData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_ORDERS.PURCHASES_ORDER_UPDATED"),
        });
        this.viewPurchasesOrder();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
